module.exports = __webpack_public_path__ + "static/media/TRIAL 3 if-both-wrong.65c9441e.mp3";